export const stringToSvg = (str: string): string => {
  const svg = new Blob([str], { type: 'image/svg+xml' })
  return URL.createObjectURL(svg)
}
